import { gql } from '@apollo/client';
export const LeaveSubtypeFragment = gql `
    fragment LeaveSubtypeFragment on StaffLeaveSubType {
        id
        leaveType
        name
        code
        paid
    }
`;
